<template>
    <div class="common-layout">
        <el-container>
            <el-container style="height: 100vh">
                <el-header>
                    <el-row :gutter="10" class="header-wrapper">
                        <el-col :span="20">
                            <div class="logo-wrapper">
                                <a
                                    href="#"
                                    class="logo-link"
                                    @click.prevent="handleLogoClick(groupName)"
                                >
                                    <img
                                        v-if="
                                            groupName == 'Deutsche Interim AG'
                                        "
                                        class="logo"
                                        src="/media/images/web_search/logo.svg"
                                        alt="Logo"
                                    />
                                    <span
                                        v-if="
                                            groupName == 'Deutsche Interim AG'
                                        "
                                        class="header-company-name"
                                    >
                                        Deutsche<br />Interim AG
                                    </span>

                                    <img
                                        v-else-if="
                                            groupName == 'Swiss Interim GmbH'
                                        "
                                        class="logo-swiss"
                                        src="/media/images/swiss/logo.png"
                                        alt="Logo"
                                    />

                                    <img
                                        v-else-if="groupName == 'Open HR'"
                                        class="logo-opnhr"
                                        src="/media/images/opnhr/opnhr_logo.svg"
                                        alt="OPNHR Logo"
                                    />

                                    <img
                                        v-else
                                        class="logo-matchmaker"
                                        src="/media/images/web_search/logo_matchmaker.svg"
                                        alt="Logo"
                                    />
                                </a>
                            </div>
                        </el-col>
                    </el-row>
                    <CandidateCart
                        v-show="mobileFilterState == false"
                        :profiles="profiles"
                        @show="$refs.CheckoutProcessRef.showModal('StartModal')"
                        :is-mobile="isMobile"
                        :group-name="groupName"
                    />
                </el-header>
                <el-main class="main-wrapper">
                    <div class="content-wrapper">
                        <el-alert
                            v-show="showSuccessAlert"
                            :title="$trans('web_search.alerts.success_login')"
                            type="success"
                            show-icon
                            :closable="true"
                            @close="showSuccessAlert = false"
                        />
                        <el-alert
                            v-show="showAlert"
                            :title="
                                $trans('web_search.alerts.max_limit_reached')
                            "
                            type="info"
                            show-icon
                            :closable="false"
                        />
                        <div class="searcher-wrapper">
                            <TabbedSearchBar
                                v-show="true"
                                @searchResults="newSearch"
                                :main-filters="mainFilters"
                                @maxCompetencesLimitReached="
                                    handleMaxCompetencesLimitReached
                                "
                                :group-name="groupName"
                                ref="tabbedSearchBarRef"
                            />
                        </div>
                        <div
                            class="results-wrapper"
                            v-if="loaded"
                            v-show="mode == 'results'"
                        >
                            <div class="content-wrapper profile-list-wrapper">
                                <input
                                    type="hidden"
                                    name="terms"
                                    :value="
                                        mainFilters
                                            .map((option) => option.name)
                                            .join(', ')
                                    "
                                />
                                <div v-if="!debugMode">
                                    <div>
                                        <SearchResult
                                            :counter="filteredProfiles.length"
                                            :filters="mainFilters"
                                            :modifier="modifier"
                                            :removed-filters="removedFilters"
                                            :results="profiles.length"
                                            @switchModifier="switchModifier"
                                            @removeFilter="removeFilter"
                                            @restoreFilter="restoreFilter"
                                            @updateSearch="updateSearch"
                                            @openSearcher="mode = 'searcher'"
                                            @showSimiliarTags="showSimiliarTags"
                                            @resetSearchResult="
                                                handleResetSearchResult
                                            "
                                            @maxCompetencesLimitReached="
                                                handleMaxCompetencesLimitReached
                                            "
                                        />
                                    </div>
                                    <div></div>
                                    <ProfileList
                                        :profiles="profiles"
                                        :tmpProfiles="filteredProfiles"
                                        ref="profileList"
                                        :filters="structuredFilters"
                                        v-if="profiles.length > 0"
                                        :main-filters="mainFilters"
                                        :group-name="groupName"
                                        @showConfirmationModal="
                                            handleShowConfirmationModal($event)
                                        "
                                        :total-count="totalProfilesCount"
                                        :is-background-loading="
                                            isBackgroundLoading
                                        "
                                    />
                                </div>
                                <div v-else>
                                    <ProfileDebug
                                        :profiles="filteredProfiles"
                                        :selected-filters="selectedFilters"
                                        :filters="flattenFilters"
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="profiles.length === 0"
                            class="profile-placeholder-wrapper"
                        >
                            <ProfileListPlaceholder />
                        </div>
                        <div v-show="mode == 'error'">
                            {{
                                $trans(
                                    "web_search.checkout_response_messages.simple_something_went_wrong",
                                )
                            }}
                        </div>

                        <AddToBoardConfirmationModal
                            v-if="isConfirmationModalVisible"
                            v-model="isConfirmationModalVisible"
                            :profile="selectedProfile"
                            @addToBoard="handleAddToBoard"
                        />

                        <CheckoutProcess
                            ref="CheckoutProcessRef"
                            :group-name="groupName"
                        />
                    </div>
                    <Footer :group-name="groupName" />
                </el-main>
            </el-container>
        </el-container>

        <el-dialog
            v-model="dialogTableVisible"
            :title="$trans('web_search.register_options.title')"
            width="800"
        >
            <el-row :gutter="10">
                <el-col :span="24" class="register-link-wrapper">
                    <el-link
                        class="client"
                        :underline="false"
                        href="[https://matchmaker.de](https://matchmaker.de)"
                        >{{
                            $trans("web_search.register_options.client")
                        }}</el-link
                    >
                    <el-link
                        class="pool-member"
                        :underline="false"
                        href="[https://matchmaker.deutscheinterim.com/register/check-email](https://matchmaker.deutscheinterim.com/register/check-email)"
                        >{{
                            $trans("web_search.register_options.candidate")
                        }}</el-link
                    >
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import ActiveFilters from "./Components/ActiveFilters";
import CandidateCart from "./Components/CandidateCart";
import CheckoutProcess from "./Components/CheckoutProcess";
import MobileFooter from "./Components/MobileFooter";
import CloseModalButton from "./Components/CheckoutProcess/CloseModalButton";
import Filters from "./Components/Filters";
import ProfileList from "./Components/ProfileList";
import ProfileDebug from "./Components/ProfileDebug";
import SearcherBackdrop from "./Components/SearcherBackdrop";
import SearchResult from "./Components/SearchResult";
import SearchWithAi from "./Components/SearchWithAi";
import ProfileListPlaceholder from "./Components/ProfileListPlaceholder";
import Footer from "./Components/Footer";
import TabbedSearchBar from "./Components/TabbedSearchBar";
import AddToBoardConfirmationModal from "./Components/CheckoutProcess/AddToBoardConfirmationModal";

import { mapStores } from "pinia";
import { useFilterOptionsStore } from "@/stores/FilterOptionsStore";
import { useSelectedFiltersStore } from "@/stores/SelectedFiltersStore";
import { useCandidateBoardStore } from "@/stores/CandidateBoardStore";

export default {
    components: {
        ActiveFilters,
        CandidateCart,
        CheckoutProcess,
        CloseModalButton,
        Filters,
        ProfileList,
        ProfileDebug,
        SearcherBackdrop,
        SearchResult,
        MobileFooter,
        SearchWithAi,
        ProfileListPlaceholder,
        TabbedSearchBar,
        Footer,
        AddToBoardConfirmationModal,
    },
    props: {
        groupName: String,
    },
    data() {
        return {
            totalProfilesCount: 0,
            isBackgroundLoading: true,
            loaded: false,
            profiles: [],
            mainFilters: [],
            removedFilters: [],
            selectedFilters: {},
            debugMode: false,
            modifier: undefined,
            mode: undefined,
            mobileFilterState: false,
            page: 1,
            showSuccessAlert: false,
            showAlert: false,
            isMobile: window.innerWidth <= 790,
            searchKindModifier: "AI",
            isConfirmationModalVisible: false,
        };
    },
    created() {
        const url = new URL(window.location.href);
        this.fetchData(url);
    },
    mounted() {
        const url = new URL(window.location.href);
        this.debugMode = url.searchParams.has("debug")
            ? !!url.searchParams.get("debug")
            : false;
        const returnUrl = url.searchParams.get("returnUrl");

        if (returnUrl) {
            sessionStorage.setItem(
                "external_return_path",
                decodeURIComponent(returnUrl),
            );
        }
    },
    methods: {
        handleLogoClick(groupName) {
            const savedUrl = sessionStorage.getItem("external_return_path");
            const group = groupName.toLowerCase();

            if (savedUrl) {
                const urlLower = savedUrl.toLowerCase();

                const isSwiss =
                    group.includes("swiss") &&
                    urlLower.includes("swissinterim");
                const isDeutsche =
                    group.includes("deutsche") &&
                    urlLower.includes("deutscheinterim");

                if (isSwiss || isDeutsche) {
                    window.location.href = savedUrl;
                    return;
                }
            }

            window.location.href = this.currentUrl + "/web-search/results/de";
        },
        handleAddToBoard(profile) {
            this.isConfirmationModalVisible = false;
            this.$refs.CheckoutProcessRef.showModal("StartModal");
        },
        handleShowConfirmationModal(profile) {
            this.selectedProfile = profile;
            this.isConfirmationModalVisible = true;
        },
        switchModifier(modifier) {
            let url = new URL(window.location.href);
            url.searchParams.set("modifier", modifier);

            this.fetchData(url);
        },
        newSearch(data) {
            this.mode = undefined;

            let currentCompetences = this.mainFilters
                .filter((f) => f.type === "competence")
                .map((f) => f.id);

            let fetchedCompetences = Array.isArray(data.competence)
                ? data.competence
                : data.competence
                  ? [data.competence]
                  : [];

            let removedIds = this.removedFilters.map((f) => String(f.id));

            let combined = [
                ...new Set([...currentCompetences, ...fetchedCompetences]),
            ]
                .filter((id) => !removedIds.includes(String(id)))
                .slice(0, 10);

            const url = new URL(window.location.href);

            if (combined.length > 0) {
                url.searchParams.set("competence", combined.join("-"));
            } else {
                url.searchParams.delete("competence");
            }

            if (data.job_tag) {
                url.searchParams.set("job_tag", data.job_tag);
            } else {
                url.searchParams.delete("job_tag");
            }

            url.searchParams.set("modifier", data.modifier || "OR");

            this.fetchData(url);

            document.title = `Suchergebnisse für ${this.mainFilters
                .map((option) => option.name)
                .join(", ")}`;
        },
        removeFilter(filter) {
            this.removedFilters.push(filter);
            this.mainFilters = this.mainFilters.filter(
                (f) => f.id !== filter.id,
            );
        },
        restoreFilter(filter) {
            this.removedFilters = this.removedFilters.filter(
                (f) => f.id !== filter.id,
            );
            this.mainFilters.push(filter);
        },
        updateSearch() {
            let url = new URL(window.location.href);

            let activeCompetences = this.mainFilters
                .filter((f) => f.type === "competence")
                .map((f) => f.id);

            if (activeCompetences.length > 0) {
                url.searchParams.set("competence", activeCompetences.join("-"));
            } else {
                url.searchParams.delete("competence");
            }

            this.fetchData(url);
        },
        handleUrlProfiles(fetchedProfiles) {
            const url = new URL(window.location.href);
            const profilesParam = url.searchParams.get("profiles");

            if (profilesParam && fetchedProfiles.length > 0) {
                const idsToSelect = profilesParam.split("-");
                const profilesToAdd = fetchedProfiles.filter((p) =>
                    idsToSelect.includes(p.id.toString()),
                );

                if (profilesToAdd.length > 0) {
                    profilesToAdd.forEach((profile) => {
                        this.CandidateBoardStore.addToBoard(profile);
                    });

                    this.$nextTick(() => {
                        if (this.$refs.CheckoutProcessRef) {
                            this.$refs.CheckoutProcessRef.showModal(
                                "StartModal",
                            );
                        }
                    });
                }
            }

            url.searchParams.delete("profiles");
            window.history.replaceState({}, "", url.toString());
        },
        fetchData(url) {
            this.isBackgroundLoading = false;
            this.loaded = false;
            this.$functions.showLoader();

            history.pushState({}, "", url);
            url.searchParams.set("format", "json");

            let initialUrl = new URL(url.href);
            initialUrl.searchParams.set("limit", 10);

            this.FilterOptionsStore.clearAllOptions();
            this.profiles = [];
            this.SelectedFiltersStore.registerFilters(
                Object.keys(this.flattenFilters),
            );

            fetch(initialUrl.href)
                .then((res) => res.json())
                .then((json) => {
                    this.loaded = true;
                    this.$functions.hideLoader();

                    this.totalProfilesCount = json.total_count || 0;

                    this.FilterOptionsStore.setProfiles(json.profiles);
                    this.FilterOptionsStore.setOptions(
                        "availabilityStatus",
                        json.filters.availabilityStatus,
                    );
                    this.FilterOptionsStore.setOptions(
                        "competencies",
                        json.filters.competencies,
                    );
                    this.FilterOptionsStore.setOptions(
                        "industrySectors",
                        json.filters.industrySectors,
                    );
                    this.FilterOptionsStore.setOptions(
                        "regions",
                        json.filters.regions,
                    );
                    this.FilterOptionsStore.setOptions(
                        "companySizes",
                        json.filters.companySizes,
                    );
                    this.FilterOptionsStore.setOptions(
                        "educationLevels",
                        json.filters.educationLevels,
                    );
                    this.FilterOptionsStore.setOptions(
                        "languages",
                        json.filters.languages,
                    );

                    this.profiles = json.profiles.map((profile) => {
                        let activeTerms = json.main_filters;
                        profile.activeSkills = activeTerms.filter((filter) =>
                            profile.scores
                                .map((score) => score.type_id)
                                .includes(filter.type + "_" + filter.id),
                        );
                        return profile;
                    });

                    let fetchedFilters = json.main_filters;
                    if (this.removedFilters && this.removedFilters.length > 0) {
                        const removedIds = this.removedFilters.map(
                            (rf) => rf.id,
                        );
                        fetchedFilters = fetchedFilters.filter(
                            (f) => !removedIds.includes(f.id),
                        );
                    }
                    this.mainFilters = fetchedFilters;

                    this.mainFilters = this.connectWithColorCodes();
                    this.modifier = json.modifier;

                    const currentUrl = new URL(window.location.href);
                    if (currentUrl.searchParams.has("profiles")) {
                        this.mainFilters.forEach((filter) => {
                            if (filter.type === "competence") {
                                this.SelectedFiltersStore.setState(
                                    "competencies",
                                    filter.id,
                                    true,
                                );
                            }
                        });
                    }
                    if (
                        this.mainFilters.length ||
                        (this.profiles.length > 0 &&
                            currentUrl.searchParams.has("profiles"))
                    ) {
                        this.mode = "results";
                    } else {
                        this.mode = "searcher";
                    }

                    this.callChildMethod();
                    this.handleUrlProfiles(json.profiles);

                    let backgroundUrl = new URL(url.href);
                    backgroundUrl.searchParams.set("offset", 10);

                    this.fetchBackgroundData(backgroundUrl);
                })
                .catch((error) => {
                    console.log(error);
                    this.$functions.hideLoader();
                })
                .finally(() => {
                    this.SelectedFiltersStore.registerFilters(
                        Object.keys(this.flattenFilters),
                    );
                    this.loaded = true;
                    this.$functions.hideLoader();

                    const finalUrl = new URL(window.location.href);
                    if (finalUrl.searchParams.has("returnUrl")) {
                        finalUrl.searchParams.delete("returnUrl");
                        window.history.replaceState(
                            {},
                            "",
                            finalUrl.pathname + finalUrl.search,
                        );
                    }
                });
        },
        fetchBackgroundData(url) {
            fetch(url.href)
                .then((res) => res.json())
                .then((json) => {
                    const activeTerms = json.main_filters || [];
                
                    const newProfiles = (json.profiles || []).map((profile) => {
                        const scoresIds = (profile.scores || []).map((score) => score.type_id);
                    
                        profile.activeSkills = activeTerms.filter((filter) =>
                            scoresIds.includes(`${filter.type}_${filter.id}`)
                        );
                        return profile;
                    });
                
                    this.profiles = [...this.profiles, ...newProfiles];
                    this.FilterOptionsStore.setProfiles(this.profiles);
                
                    if (json.filters) {
                        Object.entries(json.filters).forEach(([key, filterValues]) => {
                            if (Array.isArray(filterValues) && filterValues.length > 0) {
                                this.FilterOptionsStore.setOptions(key, filterValues);
                            }
                        });
                    }
                
                    this.handleUrlProfiles(newProfiles);
                    this.totalProfilesCount = this.profiles.length;
                    this.isBackgroundLoading = false;
                })
                .catch((error) => {
                    console.error("Błąd podczas pobierania danych w tle:", error);
                    this.isBackgroundLoading = false;
                });
        },
        callChildMethod() {
            const childComponent = this.$refs.profileList;

            if (childComponent) {
                childComponent.resetPage();
            } else {
                console.error("Child component reference is undefined.");
            }
        },
        setSearchKind(kind) {
            if (this.searchKindModifier !== kind) {
                this.searchKindModifier = kind;
            }
        },
        handleShowSuccessLoginAlert() {
            this.showSuccessAlert = true;
            setTimeout(() => {
                this.showSuccessAlert = false;
            }, 5000);
            this.$functions.hideLoader();
            return;
        },
        updateIsMobile() {
            this.isMobile = window.innerWidth <= 790;
        },
        switcherBackground() {
            return {
                background:
                    this.searchKindModifier === "AI"
                        ? "linear-gradient(90deg, #a06dd6, #9e6ed6, #8f7ad1, #8682cf, #8385ce, #7e89cd, #7a8dcc, #7690ca, #7294c9, #6d9ac7, #6d9ac7, #699fc6, #68a0c6, #67a2c5)"
                        : "#41abc4",
            };
        },
        toggleSearchKind() {
            this.searchKindModifier =
                this.searchKindModifier === "AI" ? "KEYWORD" : "AI";
            this.fetchSearchResults();
        },
        resetState() {
            this.profiles = [];
            this.loaded = false;
            this.mainFilters = [];
            this.selectedFilters = {};
            this.debugMode = false;
            this.modifier = "OR";
            this.mode = undefined;
            this.mobileFilterState = false;
            this.page = 1;
            this.isOpen = false;
            this.showContent = false;
            this.searchKindModifier = "AI";
        },
        handleResetSearchResult() {
            this.profiles = [];
            this.loaded = false;
            this.mainFilters = [];
            this.selectedFilters = {};
            this.debugMode = false;
            this.modifier = "OR";
            this.mode = undefined;
            this.mobileFilterState = false;
            this.page = 1;
            this.isOpen = false;
            this.showContent = false;
            this.searchKindModifier = "AI";

            let searchInput = document.getElementById("search-input");
            if (searchInput) {
                searchInput.value = "";
                searchInput.style.height = "15px";
            }

            const urlWithoutParams =
                window.location.origin + window.location.pathname;
            window.history.pushState({}, "", urlWithoutParams);
            this.$refs?.tabbedSearchBarRef?.$refs?.searcherRef?.resetHierarchy();
        },
        connectWithColorCodes() {
            const colors = [
                "#999b77",
                "#809877",
                "#6b958a",
                "#6d97a5",
                "#7180a8",
                "#8c7caa",
                "#aa7c98",
                "#bc7575",
                "#b49a77",
                "#8a8f9a",
            ];

            let assignedColors = {};

            return this.mainFilters.map((filter, index) => {
                if (index < colors.length) {
                    assignedColors[filter.id] = colors[index];
                } else {
                    const randomColor =
                        colors[Math.floor(Math.random() * colors.length)];
                    assignedColors[filter.id] = randomColor;
                }
                return { ...filter, color: assignedColors[filter.id] };
            });
        },
        handleSearchResults() {},
    },
    computed: {
        ...mapStores(useFilterOptionsStore),
        ...mapStores(useSelectedFiltersStore),
        ...mapStores(useCandidateBoardStore),
        structuredFilters() {
            let filters = this.FilterOptionsStore.getAllOptions();

            const sortByOccurrences = (options, profiles, key) => {
                return options
                    .filter((option) => option && option.id != null)
                    .map((option) => {
                        const count = profiles.filter((profile) => {
                            switch (key) {
                                case "competencies":
                                    return profile.filter_competencies.includes(
                                        Number(option.id),
                                    );
                                case "industrySectors":
                                    return profile.filter_industry_sectors.includes(
                                        Number(option.id),
                                    );
                                case "regions":
                                    return profile.filter_regions.includes(
                                        option.id,
                                    );
                                case "languages":
                                    return profile.filter_languages.includes(
                                        option.id,
                                    );
                                case "educationLevels":
                                    return profile.filter_education.includes(
                                        Number(option.id),
                                    );
                                case "companySizes":
                                    return profile.filter_company_sizes.includes(
                                        Number(option.id),
                                    );
                                case "availabilityStatus":
                                    return (
                                        profile.availability_status == option.id
                                    );
                                default:
                                    return false;
                            }
                        }).length;

                        return { ...option, occurrences: count };
                    })
                    .sort((a, b) => {
                        if (b.occurrences !== a.occurrences) {
                            return b.occurrences - a.occurrences;
                        }
                        if (a.name && b.name) {
                            return a.name.localeCompare(b.name);
                        }
                        return 0;
                    });
            };

            let structuredFilters = {
                competencies: {
                    title: this.$trans(
                        "web_search.filter_names.qualifications",
                    ),
                    options: sortByOccurrences(
                        filters.competencies,
                        this.profiles,
                        "competencies",
                    ),
                    searchbar: true,
                    modifierSwitch: true,
                    hidden: filters.competencies.length == 0,
                },
                industrySectors: {
                    title: this.$trans(
                        "web_search.filter_names.industry_sectors",
                    ),
                    options: sortByOccurrences(
                        filters.industrySectors,
                        this.profiles,
                        "industrySectors",
                    ),
                    hidden: filters.industrySectors.length == 0,
                },
                availabilityStatus: {
                    title: this.$trans("web_search.filter_names.availability"),
                    options: filters.availabilityStatus,
                    modifierState: "OR",
                    hidden: filters.availabilityStatus.length == 0,
                },
                regions: {
                    title: this.$trans("web_search.filter_names.regions"),
                    filters: filters.regions,
                    hidden: filters.regions.length == 0,
                },
                companySizes: {
                    title: this.$trans("web_search.filter_names.company_size"),
                    options: filters.companySizes,
                    hidden: filters.companySizes.length == 0,
                    maxLength: -1,
                },
                educationLevels: {
                    title: this.$trans("web_search.filter_names.education"),
                    filters: filters.educationLevels,
                    hidden: filters.educationLevels.length == 0,
                },
                languages: {
                    title: this.$trans("web_search.filter_names.languages"),
                    filters: filters.languages,
                    hidden: filters.languages.length == 0,
                },
            };

            return structuredFilters;
        },

        flattenFilters() {
            return this.FilterOptionsStore.getAllFlattenOptions();
        },
        filteredProfiles() {
            let activeFilters = this.SelectedFiltersStore.getActiveFilters();
            let modifiers = this.SelectedFiltersStore.getModifiers();
            this.callChildMethod();

            if (this.SelectedFiltersStore.getActiveFiltersCount() == 0) {
                return this.profiles;
            }

            let tmpProfiles = this.profiles;

            return tmpProfiles
                .filter((profile) => {
                    if (activeFilters.availabilityStatus.length == 0) {
                        return true;
                    }

                    if (
                        Object.hasOwn(modifiers, "availabilityStatus") &&
                        modifiers.availabilityStatus == "OR"
                    ) {
                        return activeFilters.availabilityStatus.some(
                            (optionId) => {
                                return profile.availability_status == optionId;
                            },
                        );
                    }

                    return activeFilters.availabilityStatus.every(
                        (optionId) => {
                            return profile.availability_status == optionId;
                        },
                    );
                })
                .filter((profile) => {
                    if (activeFilters.competencies.length == 0) {
                        return true;
                    }
                    if (
                        Object.hasOwn(modifiers, "competencies") &&
                        modifiers.competencies == "OR"
                    ) {
                        return activeFilters.competencies.some((optionId) => {
                            return profile.filter_competencies.includes(
                                parseInt(optionId),
                            );
                        });
                    }

                    return activeFilters.competencies.every((optionId) => {
                        return profile.filter_competencies.includes(
                            parseInt(optionId),
                        );
                    });
                })
                .filter((profile) => {
                    if (activeFilters.industrySectors.length == 0) {
                        return true;
                    }

                    if (
                        Object.hasOwn(modifiers, "industrySectors") &&
                        modifiers.industrySectors == "OR"
                    ) {
                        return activeFilters.industrySectors.some(
                            (optionId) => {
                                return profile.filter_industry_sectors.includes(
                                    parseInt(optionId),
                                );
                            },
                        );
                    }

                    return activeFilters.industrySectors.every((optionId) => {
                        return profile.filter_industry_sectors.includes(
                            parseInt(optionId),
                        );
                    });
                })
                .filter((profile) => {
                    if (activeFilters.regions.length == 0) {
                        return true;
                    }

                    if (
                        Object.hasOwn(modifiers, "regions") &&
                        modifiers.regions == "OR"
                    ) {
                        return activeFilters.regions.some((optionId) => {
                            return profile.filter_regions.includes(optionId);
                        });
                    }

                    return activeFilters.regions.every((optionId) => {
                        return profile.filter_regions.includes(optionId);
                    });
                })
                .filter((profile) => {
                    if (activeFilters.languages.length == 0) {
                        return true;
                    }

                    if (
                        Object.hasOwn(modifiers, "languages") &&
                        modifiers.languages == "OR"
                    ) {
                        return activeFilters.languages.some((optionId) => {
                            return profile.filter_languages.includes(optionId);
                        });
                    }

                    return activeFilters.languages.every((optionId) => {
                        return profile.filter_languages.includes(optionId);
                    });
                })
                .filter((profile) => {
                    if (activeFilters.educationLevels.length == 0) {
                        return true;
                    }

                    if (
                        Object.hasOwn(modifiers, "educationLevels") &&
                        modifiers.educationLevels == "OR"
                    ) {
                        return activeFilters.educationLevels.some(
                            (optionId) => {
                                return profile.filter_education.includes(
                                    parseInt(optionId),
                                );
                            },
                        );
                    }

                    return activeFilters.educationLevels.every((optionId) => {
                        return profile.filter_education.includes(optionId);
                    });
                })
                .filter((profile) => {
                    if (activeFilters.companySizes.length == 0) {
                        return true;
                    }

                    if (
                        Object.hasOwn(modifiers, "companySizes") &&
                        modifiers.companySizes == "OR"
                    ) {
                        return activeFilters.companySizes.some((optionId) => {
                            return profile.filter_company_sizes.includes(
                                parseInt(optionId),
                            );
                        });
                    }

                    return activeFilters.companySizes.every((optionId) => {
                        return profile.filter_company_sizes.includes(optionId);
                    });
                });
        },
        currentUrl() {
            return window.location.origin;
        },
        getMainFilters() {
            return this.mainFilters;
        },
    },
};
</script>

<style scoped>
.clslm-1 {
    fill: #303030;
    font-family: Barlow-Medium, Barlow;
    font-size: 26px;
    font-weight: 500;
}

.results-wrapper {
    display: flex;
    align-items: flex-start;
}

.error-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    padding: 50px;
}

.side-wrapper {
    background-color: white;
    width: 320px;
    margin: 50px 0;
    box-sizing: border-box;
    padding: 15px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.content-wrapper {
    position: relative;
    padding: 15px;
    width: calc(100vw - 320px);
    box-sizing: border-box;
}

@media only screen and (max-width: 790px) {
    .results-wrapper {
        display: block;
        margin-bottom: 64px;
    }

    .side-wrapper {
        display: none;
        position: fixed;
        z-index: 100;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius: 8px;
        width: calc(100% - 30px);
        margin: 15px;
        box-sizing: border-box;
        overflow-y: scroll;
    }

    .side-wrapper.show {
        display: block;
    }

    .content-wrapper {
        max-width: unset;
        width: 100%;
    }

    .header-wrapper {
        margin-left: 33% !important;
        margin-top: 60px;
        margin-bottom: 30px;
    }
}

/* new styles */
* {
    font-family: Barlow;
}

.common-layout {
    background-color: #ebebeb !important;
}

.header-wrapper {
    margin-top: 30px;
    margin-bottom: 30px;
    margin-left: -21px !important;
}

.start-wrapper {
    text-align: center;
    place-items: center;
    place-content: center;
}

.chatbot-wrapper {
    width: 50%;
    text-align: center;
    place-items: center;
    place-content: center;
    overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    margin-top: 60px;
    min-height: calc(100vh - 200px);
}

.messages-wrapper {
    border-bottom: 1px solid #dddddd;
    width: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
    text-align: left !important;
    display: flex;
    flex-direction: row;
}

.main-title {
    margin-bottom: 50px;
    font: normal normal 600 42px/50px Cormorant Garamond;
    letter-spacing: -1.26px;
    color: #4d5255;
}

.subtitle {
    margin-bottom: 15px;
    letter-spacing: -0.36px;
    color: #3c3c3c;
    font: normal normal normal 1rem/1.75rem Inter;
}

.logo {
    width: 115px;
}

.chat-bot-wrapper {
    width: 800px;
}

.input-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.input-wrapper-row {
    width: 100%;
    margin-top: auto;
}

.search-btn {
    background-color: #fff;
    float: right;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 0px;
    padding: 0px;
    cursor: pointer;
}

.arrow-image {
    width: 60px;
    height: 60px;
    padding: 0px;
    transform: rotate(270deg);
    filter: invert(80%) sepia(0%) saturate(43%) hue-rotate(141deg)
        brightness(98%) contrast(101%);
}

.arrow-image:hover {
    filter: invert(70%) sepia(81%) saturate(549%) hue-rotate(158deg)
        brightness(81%) contrast(88%);
}

.question-input {
    border: 0px;
    background-color: #f5f5f5 !important;
    width: 100%;
    float: left;
    font-size: 18px;
}

.question-input:focus {
    outline: none;
}

.input-group {
    border: 1px solid #c7c7c7;
    background-color: #f5f5f5 !important;
    border-radius: 20px;
    width: 100%;
    font-size: 18px;
    padding: 10px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}

.loader {
    font-size: 24px;
    float: right;
    padding: 10px;
    margin: 10px;
    border: 0px !important;
    width: 100% !important;
}

.main-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
}

.footer-wrapper {
    padding-top: 25px;
    font-size: 15px;
    letter-spacing: -0.3px;
    color: #3c3c3c;
    font-family: Inter !important;
}

.footer-wrapper a {
    color: #3c3c3c;
    font-family: Inter !important;
}

.link {
    color: #3c3c3c;
    text-decoration: none;
}

.dot {
    height: 5px;
    width: 5px;
    background-color: #41abc4;
    border-radius: 50%;
    display: inline-block;
}

.user-wrapper {
    text-align: center;
}

.avatar {
    width: 70px;
    height: 70px;
    border-radius: 50%;
}

.chat-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    overflow: scroll;
}

.message-avatar .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
}

.message-content {
    padding-left: 15px !important;
    text-align: left;
    font: normal normal normal 18px/32px Inter;
    letter-spacing: -0.36px;
    color: #3c3c3c;
}

.loader {
    color: #b5b5b5;
    width: 4px !important;
    padding: 0 !important;
    align-items: center;
    aspect-ratio: 1;
    border-radius: 50%;
    box-shadow:
        19px 0 0 7px,
        38px 0 0 3px,
        57px 0 0 0;
    transform: translateX(-38px);
    animation: l21 0.5s infinite alternate linear;
}

@keyframes l21 {
    50% {
        box-shadow:
            19px 0 0 3px,
            38px 0 0 7px,
            57px 0 0 3px;
    }

    100% {
        box-shadow:
            19px 0 0 0,
            38px 0 0 3px,
            57px 0 0 7px;
    }
}

.message-content-loader {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.loading {
    border: 0 !important;
}

.beta {
    height: 40px;
    width: 100px;
    background-color: #ea975a;
    border-radius: 24px;
    text-align: center;
    margin-left: 20px;
    top: -15px;
    position: absolute;
    color: #fff;
    font-size: 26px;
    font-family: Barlow;
    letter-spacing: 0.31px;
}

.pool-member {
    height: 200px;
    width: 200px;
    font-size: 26px;
    font-family: Inter;
    border-radius: 20px;
    border: 1px solid #b5b5b5;
}

.client {
    height: 200px;
    width: 200px;
    font-size: 26px;
    font-family: Inter;
    border-radius: 20px;
    border: 1px solid #b5b5b5;
}

.pool-member:hover {
    border-color: #b465d8;
    color: #b465d8;
}

.client:hover {
    border-color: #b465d8;
    color: #b465d8;
}

.di-link {
    text-decoration: underline;
}

.menu-links a {
    color: #fff;
    display: block;
    font-size: 18px;
    padding-bottom: 3px;
}

a.login-link {
    color: #fff;
    display: block;
    font-size: 18px;
    font-size: 18px;
    padding-bottom: 3px;
    top: -72px;
    left: 62px;
    text-decoration: none;
    color: white;
    margin-bottom: 20px;
    text-decoration: none;
}

a.login-link:hover::after {
    display: none;
}

.common-layout,
.el-container,
.el-header,
.el-main,
.el-aside {
    width: 100%;
    margin: 0;
}

body {
    margin: 0;
}

.main-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
}

.searcher-wrapper {
    z-index: 10;
    margin: 0 auto;
    width: 79%;
}

.results-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.side-wrapper {
    width: 250px;
    margin-right: 20px;
    transition: transform 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
}

.content-wrapper {
    flex-grow: 1;
}

.side-wrapper.show {
    transform: translateX(0);
}

.side-wrapper {
    transform: translateX(-100%);
}

.wrapper {
    margin-left: 10%;
}

.searcher-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.switcher-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.switcher {
    display: flex;
    align-items: center;
    gap: 10px;
}

.toggle-description {
    font-size: 1rem;
    color: #000;
    font-style: italic;
    cursor: pointer;
    transition:
        color 0.3s ease,
        transform 0.3s ease,
        opacity 0.3s ease;
    opacity: 0.8;
}

.toggle-description.selected {
    border-bottom: 1px solid #000;
    opacity: 1;
    transform: scale(1.1);
}

.toggle {
    width: 40px;
    height: 20px;
    background: #ddd;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: background 0.3s ease;
}

.toggle:hover {
    background: #bbb;
}

.toggle-handle {
    width: 18px;
    height: 18px;
    background: #ffffff;
    border-radius: 50%;
    position: absolute;
    top: 1px;
    left: 1px;
    transition:
        left 0.3s ease,
        background 0.3s ease;
}

.toggle-handle.right {
    left: 21px;
}

.start-wrapper {
    text-align: center;
    place-items: center;
    place-content: center;
    display: grid;
    justify-content: center;
}

.search-description-wrapper {
    padding-top: 25px;
    color: #252525;
}

.main-title {
    font: italic normal 500 36px/46px Cormorant Garamond;
    letter-spacing: -1.26px;
    color: #4d5255;
}

.subtitle {
    letter-spacing: -0.36px;
    color: #3c3c3c;
    font: normal normal normal 1rem/1.75rem Inter;
}

.subtitle > span {
    font: normal normal normal 600 18px/32px Inter;
}

.el-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    height: 160px;
    border-bottom: 1px solid #bcbab6;
    margin: 0 auto;
    width: 65%;
}

.el-main {
    flex: 1;
    overflow-y: auto;
    height: calc(100vh - 60px);
    padding: unset !important;
}

.common-layout {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.matchmaker {
    align-self: flex-start;
    padding-left: 10px;
    font-weight: bold;
    color: white;
}

.register-description {
    margin: 10px 15px;
    color: white;
}

.register-description button {
    background-color: white;
    color: #3c3c3c;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    display: block;
    margin: 10px auto 0;
    width: 100%;
}

.menu-links a {
    color: white;
    text-decoration: none;
    padding: 5px 0;
}

.menu-links a:last-child {
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.menu-links {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-bottom: 1px solid white;
    margin: 10px 15px;
    color: white;
    width: 90%;
}

.app-name {
    margin-left: 5%;
    color: #fff;
}

.header-text {
    display: flex;
    position: absolute;
    right: 142px;
    top: 96px;
    left: 35%;
    font: normal normal normal 21px/25px Barlow;
}

.logo-wrapper {
    display: flex;
    align-items: center;
}

.header-company-name {
    fill: #303030;
    font-family: Barlow-Medium, Barlow;
    font-size: 26px;
    font-weight: 500;
    margin-top: 34px;
}

.logo-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
}

.logo-swiss {
    width: 200px;
    margin-top: 6px;
}

.logo-matchmaker {
    width: 300px;
    margin-bottom: 13px;
    margin-top: 67px;
}

@media (max-width: 768px) {
    .icons-wrapper {
        display: block !important;
    }

    .el-header {
        padding: 5px;
        height: 115px;
    }

    .switcher-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .register-link-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .register-link-wrapper .el-link {
        margin-bottom: 10px;
    }

    .searcher-wrapper {
        margin-bottom: -7px;
    }
}

.change-search-kind-enter-active {
    transition:
        transform 0.6s ease-out,
        opacity 0.6s ease-in-out;
}

.change-search-kind-enter-from,
.change-search-kind-leave-to {
    transform: translateY(-30px) scale(0.96);
    opacity: 0;
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

@media (max-width: 768px) {
    .header-wrapper {
        margin-left: 30% !important;
        margin-top: -17px;
        margin-bottom: 40px;
    }

    .icons-wrapper {
        display: block !important;
    }

    .logo {
        width: 100px;
    }

    .beta {
        height: 22px;
        width: 60px;
        top: -20px;
        position: absolute;
        font-size: 14px;
        margin-left: -116px;
    }

    .register-link {
        right: 8vw !important;
    }

    .main-title {
        font: normal normal 600 25px/38px Cormorant Garamond;
        margin-bottom: 15px;
    }

    .subtitle {
        font: normal normal normal 12px/28px Inter;
    }

    .sidebar {
        display: none;
    }

    .chatbot-wrapper {
        width: 100% !important;
        margin-top: 0;
    }

    .message-content {
        padding-left: 34px !important;
    }

    .main-title {
        font: italic normal 500 22px/31px Cormorant Garamond;
    }

    .el-main {
        --el-main-padding: 0px;
    }
}

@media (max-width: 1900px) {
    .message-content {
        padding-left: 20px !important;
    }
}

@media (max-width: 1200px) {
    .message-content {
        padding-left: 35px !important;
    }
}

@media (max-width: 768px) {
    .logo-link {
        margin-left: -136px;
        margin-top: 19px;
    }

    .searcher-wrapper {
        width: 95%;
    }

    .el-header {
        border-bottom: unset !important;
    }

    .search-bar-wrapper .el-button {
        margin: 6px 0;
    }
}

@media (min-width: 2200px) {
    .el-header {
        width: 71%;
    }
}

@media (max-width: 768px) {
    html,
    body,
    .common-layout,
    .main-wrapper {
        overflow-x: hidden !important;
        max-width: 100vw !important;
        width: 100% !important;
    }

    .chat-bot-wrapper,
    .searcher-wrapper,
    .content-wrapper {
        max-width: 100vw !important;
        box-sizing: border-box !important;
    }
}
</style>
